import React, { useContext } from "react";
import { Link } from "react-router-dom";
import LandingNavbar from "./LandingNavbar";
import LandingFooter from "./LandingFooter";
import { CanvasContext } from "../../contexts/CanvasContext";
import { FaDesktop, FaHome } from "react-icons/fa";
import "./MobileRestricted.css";

const MobileRestricted = () => {
  const { isDarkTheme } = useContext(CanvasContext);

  return (
    <div className={`page-wrapper ${isDarkTheme ? "dark-theme" : ""}`}>
      <LandingNavbar />
      <main className="mobile-restricted-main">
        <div className="mobile-restricted-container">
          <div className="mobile-restricted-content">
            <div className="icon-wrapper">
              <FaDesktop className="desktop-icon" />
            </div>
            <h1 className="title">Editor Unavailable on Mobile</h1>
            <p className="message">
              We apologize, but our advanced editor is optimized for larger
              screens. For the best experience, please switch to a desktop or
              tablet device.
            </p>
            <Link to="/" className="cta-button">
              <FaHome className="home-icon" />
              Return to Home
            </Link>
          </div>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
};

export default MobileRestricted;
